import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import {Switch, Route} from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import Dashboard from '../../pages/authorized/Dashboard';
import Property from "../../pages/authorized/property/Property";
import PushNotification from "../../pages/authorized/settings/PushNotification";
import Country from "../../pages/authorized/Country";
import AccessControl from "../../pages/authorized/AccessControl";
import CreateProperty from "../../pages/authorized/property/CreateProperty";
import EditProperty from "../../pages/authorized/property/EditProperty";
import Agent from "../../pages/authorized/Agent";

const Private = () => {
    return (
        <div>
            <Switch>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute exact path="/property" component={Property} />
                <PrivateRoute exact path="/agent" component={Agent} />
                <PrivateRoute exact path="/push-notification" component={PushNotification} />
                <PrivateRoute exact path="/create-property" component={CreateProperty} />
                <PrivateRoute exact path="/edit-property/:property" component={EditProperty} />
                <PrivateRoute exact path="/country" component={Country} />
                <PrivateRoute exact path="/error" component={PageError} />
                <PrivateRoute exact path="/access-control" component={AccessControl} />
                <Route component={PageError} />
            </Switch>
        </div>
    )
};

export default Private;
